@switch (mode) {
@case (LabelMode.DEFAULT) {
<ng-container [ngTemplateOutlet]="default"></ng-container>
}
@case (LabelMode.INLINE) {
<ng-container [ngTemplateOutlet]="inline"></ng-container>
}
@case (LabelMode.NO_LABEL) {
<ng-container [ngTemplateOutlet]="input"></ng-container>
}
}

<ng-template #input>
  <div class="daterange-wrapper d-flex flex-column flex-md-row  {{ inputClass }}" [formGroup]="form" [ngClass]="{ 'is-invalid': isError }">
    <div class="input-group">
      <input ngbDatepicker #d1="ngbDatepicker" [type]="clearable ? 'search' : 'text'" class="form-control" [class.is-invalid]="isError"
        [placeholder]="'APP.START_DATE' | translate" formControlName="startValue" [firstDayOfWeek]="7"
        [minDate]="minPDate!" [maxDate]="maxPDate!" (click)="d1.toggle()" />
      <div class="input-group-append">
        <span class="cursor-pointer input-group-text" role="button" tabindex="0" (click)="d1.toggle()"
          (keydown.enter)="d1.toggle()" (keydown.space)="d1.toggle(); $event.preventDefault()">
          <app-keenicon name="calendar" class="cursor-pointer fs-1"></app-keenicon>
        </span>
      </div>
    </div>
    <!-- <nz-date-picker [nzFormat]="format" formControlName="startValue" [nzPlaceHolder]="'APP.START_DATE' | translate" [nzAllowClear]="false"></nz-date-picker> -->
    <div class="py-2 addon col-form-label fw-bold fs-6">
      {{ "APP.TO" | translate }}
    </div>
    <!-- <nz-date-picker [nzFormat]="format" formControlName="endValue" [nzPlaceHolder]="placeholder | translate" [nzAllowClear]="false"></nz-date-picker> -->
    <div class="input-group">
      <input ngbDatepicker #d2="ngbDatepicker" [type]="clearable ? 'search' : 'text'" class="form-control" [class.is-invalid]="isError"
        [placeholder]="'APP.END_DATE' | translate" formControlName="endValue" [firstDayOfWeek]="7" [minDate]="minPDate!"
        [maxDate]="maxPDate!" (click)="d2.toggle()" />
      <div class="input-group-append">
        <span class="cursor-pointer input-group-text" role="button" tabindex="0" (click)="d2.toggle()"
          (keydown.enter)="d2.toggle()" (keydown.space)="d2.toggle(); $event.preventDefault()">
          <app-keenicon name="calendar" class="cursor-pointer fs-1"></app-keenicon>
        </span>
      </div>

    </div>
  </div>
  
</ng-template>
<ng-template #error>
  @if (isError) {
  <span class="error">{{ errorMessage | translate }}</span>
  }
</ng-template>
<ng-template #default>
  <div class="form-group {{ classes }}">
    <label [for]="name" class="py-2 col-form-label fw-bold fs-6" [ngClass]="required ? 'required' : ''">{{ label |
      translate }}</label>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
    <ng-container [ngTemplateOutlet]="error"></ng-container>

  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline {{ classes }}">
    <label [for]="name" class="py-2 col-form-label fw-bold fs-6" [ngClass]="required ? 'required' : ''">{{ label |
      translate }}</label>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>
